import { Box } from '@hub/box';
import { Button, IconButton } from '@hub/button';
import { SearchMediumIcon } from '@hub/icon';
import React, { useContext } from 'react';
import Icon from "@scentregroup/ui/components/icon";
import usePlaceholder from '@scentregroup/shared/components/search/use-placeholder';
import { FeatureFlagsContext } from '../../../context';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SearchButton = _ref => {
  let {
    onClick,
    controlledElementId,
    sx,
    country,
    centre
  } = _ref;
  const showNewSearchBar = useContext(FeatureFlagsContext).NEXT_PUBLIC_FEAT_FLAG_SEARCH_BAR;
  const placeholder = usePlaceholder({
    country,
    centre
  });
  return /*#__PURE__*/_jsx(Box, {
    role: "search",
    sx: sx,
    "data-id": "search-button_index_SearchButton_Box",
    children: showNewSearchBar ? /*#__PURE__*/_jsx(Button, {
      "aria-label": "Open Search, you can search stores, brands, products, and more",
      variant: "transparent",
      colorScheme: "licorice",
      "aria-controls": controlledElementId,
      sx: {
        minWidth: 0,
        padding: 0
      },
      onClick: onClick,
      "data-id": "search-button_index_SearchButton_Button",
      children: /*#__PURE__*/_jsxs("div", {
        className: style.searchBar,
        "data-id": "search-button_index_SearchButton_Button_div",
        children: [/*#__PURE__*/_jsx(Icon, {
          type: "search",
          className: style.searchIcon,
          "data-id": "search-button_index_SearchButton_div_Icon"
        }), /*#__PURE__*/_jsx("div", {
          className: style.textfield,
          "data-id": "search-button_index_SearchButton_div_div",
          children: placeholder
        })]
      })
    }) : /*#__PURE__*/_jsx(IconButton, {
      icon: /*#__PURE__*/_jsx(SearchMediumIcon, {
        boxSize: "size-icon-md",
        "data-id": "search-button_index_SearchButton_SearchMediumIcon"
      }),
      "aria-label": "Open Search, you can search stores, brands, products, and more",
      variant: "transparent",
      colorScheme: "licorice",
      "aria-controls": controlledElementId,
      sx: {
        minWidth: 0,
        height: 'auto'
      },
      onClick: onClick,
      "data-id": "search-button_index_SearchButton_IconButton"
    })
  });
};